interface PaginatedResponse<ResponseType> {
  objects?: ResponseType[];
  page?: number;
  pages?: number;
  per_page?: number;
  total?: number;
}

export async function loopFetchAllPages<ResponseType>(
  fetcher: (page: number) => Promise<PaginatedResponse<ResponseType>>,
): Promise<ResponseType[]> {
  let currentPage = 1;
  const response = await fetcher(currentPage);
  const totalPages = response.pages ?? 1;

  const allObjects = response.objects ?? [];
  while (currentPage < totalPages) {
    currentPage += 1;
    const nextResponse = await fetcher(currentPage);
    allObjects.push(...(nextResponse.objects ?? []));
  }

  return allObjects;
}
